var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrongStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8 21.2L21.2 36.8M21.2 21.2L36.8 36.8M4.5236 41.2876C3.54834 40.3126 3.00029 38.9902 3 37.6112V20.3888C3.00029 19.0098 3.54834 17.6874 4.5236 16.7124L16.7124 4.5236C17.6874 3.54834 19.0098 3.00029 20.3888 3H37.6112C38.9902 3.00029 40.3126 3.54834 41.2876 4.5236L53.4764 16.7124C54.4517 17.6874 54.9997 19.0098 55 20.3888V37.6112C54.9997 38.9902 54.4517 40.3126 53.4764 41.2876L41.2876 53.4764C40.3126 54.4517 38.9902 54.9997 37.6112 55H20.3888C19.0098 54.9997 17.6874 54.4517 16.7124 53.4764L4.5236 41.2876Z",
    stroke: "#FC6068",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongStoreIcon);
export default __webpack_public_path__ + "static/media/wrong-store-icon.619a5e6ab4cf80acedf811a59e2d619d.svg";
export { ForwardRef as ReactComponent };